import React, { useState } from 'react';
import { Dropdown, DropdownList } from '.';
import Icon, { IconType } from '../../icons/Icon';

interface TableDropdownProps<T> {
  items: T[];
  value: T;
  onSelect: (item: T) => void;
  textBuilder: (item: T) => string;
}

export default function TableDropdown<T>({ items, value, onSelect, textBuilder }: TableDropdownProps<T>) {
  const [open, setOpen] = useState(false);

  const handleSelect = (item: T) => {
    onSelect(item);
    setOpen(false);
  };

  return (
    <Dropdown
      open={open}
      setOpen={setOpen}
      width={200}
      dropdown={<DropdownList items={items} textBuilder={textBuilder} onClick={handleSelect} />}
    >
      <button
        onClick={() => setOpen(open => !open)}
        className='z-10 flex h-[28px] w-fit items-center gap-3 rounded-2 bg-gray-disabled stroke-black px-2 py-1.5 text-left text-black'
      >
        <p>{textBuilder(value)}</p>
        <Icon type={IconType.chevronDown} size={'h-4 w-4'} />
      </button>
    </Dropdown>
  );
}
